export const RADIO_CHECKED_ICON = "itaufonts_radio_selected";
export const RADIO_ICON = "itaufonts_senha_stroke_slim";
//# sourceMappingURL=constants.js.map